import { toggleCollapse } from '../../../javascripts/utils/collapse';
import { t } from '../../../javascripts/utils/withTranslation';

document.querySelectorAll('.teaser__collapse-toggle').forEach(($toggle) => {
  $toggle?.addEventListener('click', (event) => {
    toggleCollapse($toggle, {
      closedButtonText: t('Mehr Informationen'),
      openButtonText: t('Weniger Informationen'),
      toggleClass: 'icon-link',
      toggleTextClass: 'icon-link__text',
      scrollTargetClass: 'teaser',
    });
  });
});
